import {
  formatDateOnlyForDisplay,
  requireDateOnlyString,
  type DateOnlyString,
} from "../utils/dateOnly";
import type { StickerLabelData } from "./stickerLabelPrinter.service";

export interface RequisitionStickerLabelInput {
  caseId: string;
  caseNumber: string;
  patientFirstName?: string | null;
  patientLastName?: string | null;
  dateOfService?: DateOnlyString | null;
  specimenCount: number;
  itemSlotId?: string;
}

function formatPatientName(
  firstName?: string | null,
  lastName?: string | null
) {
  const first = firstName?.trim() ?? "";
  const last = lastName?.trim() ?? "";

  if (last && first) return `${last}, ${first}`;
  if (last) return last;
  if (first) return first;
  return "Unknown Patient";
}

function formatDateOfService(dateOfService?: DateOnlyString | null) {
  if (!dateOfService) return "";
  return formatDateOnlyForDisplay(
    requireDateOnlyString(dateOfService, "Date of service")
  );
}

export function buildRequisitionStickerLabel(
  input: RequisitionStickerLabelInput
): StickerLabelData {
  return {
    itemSlotId: input.itemSlotId ?? `${Date.now()}-req`,
    itemType: "requisition",
    caseId: input.caseId,
    itemId: "",
    caseNumber: input.caseNumber,
    patientName: formatPatientName(
      input.patientFirstName,
      input.patientLastName
    ),
    specimen: "",
    blockId: "",
    slideId: "",
    stain: "",
    dateOfService: formatDateOfService(input.dateOfService),
    partsLabel:
      input.specimenCount > 0
        ? `${input.specimenCount} Part${input.specimenCount === 1 ? "" : "s"}`
        : undefined,
    barcodeValue: input.caseNumber,
  };
}
